import { Link } from "react-router-dom";

const LOGO_SRC = "https://customer-assets.emergentagent.com/job_islandhop-explore/artifacts/rw1lwv1s_WhatsApp%20Image%202026-05-18%20at%2017.58.52.jpeg";

export const Logo = ({ className = "", showWord = true, size = 36 }) => {
  return (
    <Link to="/" className={`flex items-center gap-2.5 group ${className}`} data-testid="brand-logo">
      <span
        className="relative inline-flex items-center justify-center rounded-lg overflow-hidden bg-black border border-ih-line2"
        style={{ width: size, height: size }}
      >
        <img
          src={LOGO_SRC}
          alt="IslandHop"
          className="w-full h-full object-cover"
          style={{ objectPosition: "50% 38%", transform: "scale(2.1)" }}
          draggable="false"
        />
      </span>
      {showWord && (
        <span className="font-display font-extrabold tracking-tight text-white text-lg leading-none">
          island<span className="text-ih-gold">hop</span>
        </span>
      )}
    </Link>
  );
};

export default Logo;
